import React, { Component } from "react";

import UserHeader from "./SubLayout/UserHeader";

import Footer from "../Layouts/SubLayout/Footer";

import ConsentGate from "../Legal/ConsentGate";

import AccountCompletionGate from "../Account/AccountCompletionGate";

import GlobalAnnouncementBanner from "./GlobalAnnouncement/GlobalAnnouncementBanner";

class UserLayout extends Component {
  constructor(props) {
    super(props);

    this.eventEmitter = this.props.screenProps;

    let userId =
      localStorage.getItem("userId") !== "" &&
      localStorage.getItem("userId") !== null &&
      localStorage.getItem("userId") !== undefined
        ? localStorage.getItem("userId")
        : "";

    let accessToken =
      localStorage.getItem("accessToken") !== "" &&
      localStorage.getItem("accessToken") !== null &&
      localStorage.getItem("accessToken") !== undefined
        ? localStorage.getItem("accessToken")
        : "";

    this.state = {
      isAuthenticated: userId && accessToken ? true : false,
    };
  }

  render() {
    const { isAuthenticated } = this.state;

    return (
      <div className="wrapper">
        {isAuthenticated ? <ConsentGate /> : null}
        {isAuthenticated ? <AccountCompletionGate /> : null}
        <GlobalAnnouncementBanner />
        <UserHeader />
        <div className="main-sec-content">
          {React.cloneElement(this.props.children, {
            eventEmitter: this.eventEmitter,
            data: isAuthenticated,
          })}
        </div>
        <Footer />
      </div>
    );
  }
}
export default UserLayout;
